/// <amd-module name="Analytics/Shared/ChartSeries/PassPercentSeries" />
import { ChartSeries } from "Analytics/Shared/ChartSeries/ChartSeries";
import * as Resources from "Analytics/Shared/ChartSeries/Resources";
import * as ChartDataConverter from "Analytics/Shared/Common/Utils/ChartDataConverter";

export class PassPercentSeries extends ChartSeries {
    public get maxValue(): number {
        return 100;
    }

    public get allowDecimal(): boolean {
        return true;
    }

    public get name(): string {
        return Resources.PassRate;
    }

    public get color(): string {
        return PassPercentSeries.PassedColorPalette;
    }

    public get values(): number[] {
        return ChartDataConverter.formatData(this._data);
    }

    private static readonly PassedColorPalette: string = "#107C10";
}
